import React, { useEffect, useState } from "react";

export default function SubCategoria({ vCategoria }) {
  const [vColor, setVColor] = useState({});

  useEffect(() => {
    try {
      // Convertir string a JSON
      const jsonData = JSON.parse(vCategoria.color_base.replace(/'/g, '"'));
      setVColor(jsonData);
    } catch (error) {}
  }, []);

  return (
    <div
      style={{
        backgroundColor: vColor.background_color,
        color: vColor.text_color,
      }}
      data-figma-id="4541:19861"
      class="areas-3"
    >
      <p data-figma-id="4541:19862" class="area-texto">
        {vCategoria.nombre}
      </p>
    </div>
  );
}
